import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, Form, FormField, Grid, Heading, Image, Main, ResponsiveContext, Select, Stack, Table, TableBody, TableCell, TableHeader, TableRow, Text, TextArea, TextInput, Tip } from "grommet";
import * as React from "react";
import axios from "./general/HttpClient";
import StyledModal from "./components/StyledModel";
import CardView from "./CardView";
import ThemeViewOld from "./ThemeViewOld";
import { BrowseThemes, CreateTheme, DeleteTheme, GenerateThemes, Theme } from "./ThemeStore";
import { SDImage } from "./images/ImagesStore";

// import example from "./exampledata.json";

export interface Card {
    id: number;
    version: string;
    name: string;
    type: string;
    cost: string;
    cardCost: CardCost;
    damage: number | null;
    health: number | null;
    color: string;
    abilityText: string;
    themeID: number;
    theme: Theme;
    imageID: number;
    image: SDImage;
    imagePrompt: string;
    rarity: string;
    attackStrategy: string;
    victoryCondition: string;
}

export interface CardCost {
    knowledge: number;
    artifact: number;
    currency: number;
    energy: number;
}

let eventSource;

const Home = () => {
    const [cards, setCards] = React.useState([] as Card[]);
    const [themes, setThemes] = React.useState([] as Theme[]);
    const [resources, setResources] = React.useState([] as string[]);

    React.useEffect(() => {
        getThemes();
    }, []);

    React.useEffect(() => {
        browse();
    }, [themes]);

    const [message, setMessage] = React.useState("" as string);
    const [loading, setLoading] = React.useState(false);

    const [_prompt, setPrompt] = React.useState("" as string);

    const [showThemesModal, setShowThemesModal] = React.useState(false);
    const [showResourcesModal, setShowResourcesModal] = React.useState(false);

    const [selectedTheme, setSelectedTheme] = React.useState({} as Theme);

    const generate = () => {
        let now = new Date();
        const _messages = [] as string[];
        setLoading(true);
        setMessage("Starting generation...");
        if (!eventSource) {
            eventSource = new EventSource("/api/cards/generate?prompt=" + _prompt + "&amount=5&themeID=" + selectedTheme.id, { withCredentials: true });

            eventSource.onmessage = (event) => {
                console.log(event.data);

                if (event.data.indexOf("cards") == 0) {
                    setMessage("Generating Cards");
                }

                if (event.data.indexOf("ability") == 0) {
                    setMessage("Generating Ability" + event.data.substring(7));
                }

                if (event.data.indexOf("image") == 0) {
                    setMessage("Generating Image" + event.data.substring(5));
                }

                if (event.data.indexOf("done") == 0) {
                    setMessage("Finished" + event.data.substring(4) + " cards in " + (new Date().getTime() - now.getTime()) / 1000 + "s");

                    eventSource.close();
                    eventSource = null;
                    browse();
                    setLoading(false);
                }
            };
        }

        // axios.get("/api/cards/generate", { params: { prompt: "" } }).then((response) => {
        //     setCards(response.data);
        // });
    };

    const browse = () => {
        axios.get("/api/cards/browse", { params: { filter: "" } }).then((response) => {
            setCards(response.data);
        });
    };

    const getThemes = () => {
        BrowseThemes().then((response) => {
            setThemes(response.data);
        });
    };

    const browseThemes = () => {
        BrowseThemes().then((response) => {
            setThemes(response.data);
            setShowThemesModal(true);
        });
    };

    const generateThemes = () => {
        GenerateThemes(_prompt).then((response) => {
            setThemes(response.data);
            setShowThemesModal(true);
        });
    };

    const listThemes = () => {
        axios.get("/api/cards/listThemes").then((response) => {
            setThemes(response.data.map((t) => ({ name: t })));
            setShowThemesModal(true);
        });
    };

    const listResources = () => {
        axios.get("/api/cards/listResources").then((response) => {
            setResources(response.data);
            setShowResourcesModal(true);
        });
    };

    const [showCreateThemeModal, setShowCreateThemeModal] = React.useState(false);
    const [newThemeName, setNewThemeName] = React.useState("" as string);

    const startCreateTheme = () => {
        setShowCreateThemeModal(true);
    };

    const createTheme = () => {
        CreateTheme(newThemeName).then((response) => {
            getThemes();
            setShowCreateThemeModal(false);
        });
    };

    const deleteTheme = () => {
        DeleteTheme(selectedTheme).then((response) => {
            getThemes();
        });
    };

    const size = 0.8;
    // background={{ image: "url(/images/header.png)", size: "100vw", position: "top" }}
    return (
        <Box align="center" style={{ backgroundAttachment: "fixed" }}>
            <Box background={{ color: "background", opacity: 0.5 }} pad={{ horizontal: "small" }}>
                <Heading level={2}>Project Collect</Heading>
                {!loading && (
                    <Box>
                        <FormField label="Prompt">
                            <TextArea value={_prompt} rows={5} onChange={(e) => setPrompt(e.target.value)}></TextArea>
                        </FormField>
                        <FormField label="Theme">
                            <Select options={themes} value={selectedTheme} labelKey="name" onChange={({ value }) => setSelectedTheme(value)}></Select>
                        </FormField>
                        <Box direction="row" pad="small" gap="small">
                            <Button label="Generate New Cards" onClick={generate} disabled={!selectedTheme.id}></Button>

                            <Button label="Generate New Themes" onClick={generateThemes}></Button>
                            <Button label="Create a Theme" onClick={startCreateTheme}></Button>
                            <Button label="Browse Themes" onClick={browseThemes}></Button>
                            <Button label="List Existing Themes" onClick={listThemes}></Button>

                            <Button label="List Existing Resources" onClick={listResources}></Button>
                            <Button color="status-critical" label="Delete Selected Theme" onClick={deleteTheme}></Button>
                        </Box>
                    </Box>
                )}

                <Box>
                    <Text>{message}</Text>
                </Box>

                <Box direction="row" pad="small" gap="small" wrap style={{ zoom: 0.6 }}>
                    {cards.map((card) => (
                        <CardView card={card} key={card.id} onUpdate={browse}></CardView>
                    ))}
                </Box>

                <StyledModal isOpen={showThemesModal} setIsOpen={() => setShowThemesModal(false)}>
                    <Box pad="small" width="medium">
                        {themes.map((theme) => (
                            <ThemeViewOld key={"t" + theme.id} theme={theme} onUpdate={getThemes}></ThemeViewOld>
                        ))}
                    </Box>
                </StyledModal>

                <StyledModal isOpen={showResourcesModal} setIsOpen={() => setShowResourcesModal(false)}>
                    <Box pad="small" width="medium">
                        {resources.map((resource) => (
                            <Text key={resource}>{resource}</Text>
                        ))}
                    </Box>
                </StyledModal>
                <StyledModal isOpen={showCreateThemeModal} setIsOpen={() => setShowCreateThemeModal(false)}>
                    <Box pad="small" width="medium">
                        <FormField label="Name">
                            <TextInput value={newThemeName} onChange={(e) => setNewThemeName(e.target.value)}></TextInput>
                        </FormField>

                        <Box direction="row" gap="small" justify="end">
                            <Button label="Cancel" onClick={() => setShowCreateThemeModal(false)}></Button>
                            <Button label="Create" onClick={createTheme}></Button>
                        </Box>
                    </Box>
                </StyledModal>
            </Box>
        </Box>
    );
};

export default Home;
